<template>
  <Base-swiper :swiper-options="swiperOptions">
    <swiper-slide v-for="item in swiperList" :key="item.key">
      <div class="swiper-img" :style="{ backgroundImage: `url(${item.icon})` }"></div>
    </swiper-slide>
  </Base-swiper>
</template>
<script>
import { swiperSlide } from "vue-awesome-swiper";
export default {
  name: "TheSwiper",
  components: { swiperSlide },
  data() {
    return {
      swiperOptions: {
        loop: true,
        loopedSlides: 5,
        slidesPerView: "auto",
        initialSlide: 0,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          //type: 'fraction',
          //type : 'progressbar',
          //type : 'custom',
          progressbarOpposite: true, //使进度条分页器与Swiper的direction参数相反
          bulletElement: "li", //设定分页器指示器（小点）的HTML标签。
          dynamicBullets: false, //动态分页器，当你的slide很多时，开启后，分页器小点的数量会部分隐藏。
          dynamicMainBullets: 5, //动态分页器的主指示点的数量
          hideOnClick: false, //默认分页器会一直显示。这个选项设置为true时点击Swiper会隐藏/显示分页器。
          clickable: true, //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
        },
        on: {
          transitionStart: () => {
            this.swiperShow = false;
          },
          transitionEnd: () => {
            this.swiperShow = true;
          },
          slideChangeTransitionEnd: () => {
            // if (this.swiper) this.active = this.swiper.realIndex;
          },
        },
      },
      swiperList: [
        {
          path: "/home-page",
          icon: require("@/assets/images/swiper-home.jpg"),
          // icon: require('@/assets/images/swiper-protect.png'),
          key: "home-page",
        },
        {
          path: "/privacy-protect",
          icon: require("@/assets/images/swiper-protect.jpg"),
          key: "privacy-protect",
        },
        {
          path: "/privacy-manage",
          icon: require("@/assets/images/swiper-manage.jpg"),
          key: "privacy-manage",
        },
        {
          path: "/privacy-policy",
          icon: require("@/assets/images/swiper-policy.jpg"),
          key: "privacy-policy",
        },
        {
          path: "/privacy-attestation",
          icon: require("@/assets/images/swiper-attest.jpg"),
          key: "privacy-attestation",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.swiper-main {
  width: 100%;
  ::v-deep .swiper-container {
    .swiper-pagination {
      height: 0.14rem;
      font-family: PingFangSC-Regular;
      font-size: 0.156rem;
      line-height: 0.14rem;
      bottom: 0.61rem;
      .swiper-pagination-bullet {
        background: #fff;
        opacity: 0.6;
        height: 0.14rem;
        border-radius: 0.07rem;
        width: 0.14rem;
        transition: all 0.2s; //可设置缓慢变化
      }
      .swiper-pagination-bullet-active {
        width: 0.54rem;
      }
    }
  }
}

.swiper-img {
  /* stylelint-disable-next-line CssSyntaxError */
  width: 100%;
  height: 8rem;
  background-repeat: no-repeat;
  background-size: cover;
}

.swiper-main-mobile {
  .swiper-img {
    /* stylelint-disable-next-line CssSyntaxError */
    height: 14.85rem;
  }
  ::v-deep .swiper-container {
    .swiper-pagination {
      height: 0.33em;
      line-height: 0.33rem;
      bottom: 1.02rem;
      .swiper-pagination-bullet {
        background: #fff;
        opacity: 0.6;
        height: 0.33rem;
        border-radius: 0.16rem;
        width: 0.33rem;
        transition: all 0.2s; //可设置缓慢变化
      }
      .swiper-pagination-bullet-active {
        width: 1.26rem;
      }
    }
  }
}
</style>
